// 接口地址
module.exports = {
  baseUrl: process.env.VUE_APP_URL
};
